module.exports = "/desktop-app/assets/img/avatar-default.png?fc58cd8865469bb0aab79e0a3b85dbc2";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/images/icon/avatar-default.png
// module id = QPNh
// module chunks = 1